import React from "react";
import { ClientAuthProvider, useClientAuth } from "./ClientAuthContext";
import type { ClientView } from "./types";
import ClientLoginView from "./views/ClientLoginView";
import ClientSignupView from "./views/ClientSignupView";
import ClientAppointmentsView from "./views/ClientAppointmentsView";
import ClientOtpView from "./views/ClientOtpView";

function ClientDashboardFlowInner({ onClose }: { onClose: () => void }) {
    const { state } = useClientAuth();
    const [view, setView] = React.useState<ClientView>(() => {
        if (!state.isLoggedIn) return "login";
        if (!state.isVerified) return "otp";
        return "dashboard";
    });

    // Auto-switch based on auth/verification state
    React.useEffect(() => {
        if (state.isLoggedIn) {
            if (!state.isVerified && view !== "otp") {
                // Switch to OTP screen when logged in but not verified
                setView("otp");
            } else if (state.isVerified && view !== "dashboard") {
                // Switch to dashboard when verified
                setView("dashboard");
            }
        }
    }, [state.isLoggedIn, state.isVerified, view]);

    if (view === "login") {
        return (
            <ClientLoginView
                onClose={onClose}
                onSwitchToSignup={() => setView("signup")}
            />
        );
    }

    if (view === "signup") {
        return (
            <ClientSignupView
                onClose={onClose}
                onSwitchToLogin={() => setView("login")}
            />
        );
    }

    if (view === "otp") {
        return (
            <ClientOtpView
                onClose={onClose}
                onBack={() => setView("login")}
                onVerified={() => setView("dashboard")}
            />
        );
    }

    return <ClientAppointmentsView onClose={onClose} />;
}

export default function ClientDashboardFlow({ onClose }: { onClose: () => void }) {
    return (
        <ClientAuthProvider>
            <ClientDashboardFlowInner onClose={onClose} />
        </ClientAuthProvider>
    );
}

